import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-billing-address',
  templateUrl: './billing-address.component.html',
  styleUrls: ['./billing-address.component.css']
})

export class BillingAddressComponent {

  public rawPhoneBilling = '';
  @Input('billingAddressGroup') public billingAddressForm: FormGroup;
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/billing-address/billing-address.component.ts